export const WEDDING_TEXTS_GENERATED = 'WEDDING_TEXTS_GENERATED';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/weddingTextGenerated.js